import { useState, useEffect, HTMLAttributes } from "react"

type HeaderProps = {
  img?: string;
  imgAlt?: string;
  titleText: string;
} & HTMLAttributes<any>

export const AppHeader = (props: HeaderProps) => {
  const [smoothStyle, setSmoothStyle] = useState("smoothTextTrigger")
  const [hdrClass, setHdrClass] = useState('nav-init')

  useEffect(() => {
    let gnavScrlPos = 0
    const scrollLister = () => {
      const y = window.scrollY
      if (y <= 0) {
        setHdrClass('nav-init')
      } else if (y - gnavScrlPos > 0) {
        setHdrClass('UpMove')
      } else if (y - gnavScrlPos < -10) {
        setHdrClass('DownMove')
      }
      gnavScrlPos = y
    }
    window.addEventListener('scroll', scrollLister)
    setSmoothStyle("smoothTextTrigger smoothTextAppear")

    return function cleanUp() {
      window.removeEventListener('scroll', scrollLister)
    }
  }, [smoothStyle])

  return <>
    <header className="hdr">
      <div id="hdr__nav" className={`hdr__nav ${hdrClass}`}>
        <h1 className="hdr__nav__logo">Family Works</h1>
      </div>
      <div className="hdr__title">
        <div className="hdr__title__wrapper">
          {props.img && <div className="hdr__title__e"><span className="smoothText"><span className={smoothStyle}><img src={props.img} alt={props.imgAlt} /></span></span></div>}
          <div className="hdr__title__j"><h2><span className="smoothText"><span className={smoothStyle}>{props.titleText}</span></span></h2></div>
        </div>
      </div>
    </header>
  </>
}